import { ResponseMeta, ResponseWarningQueries } from "../types/response";
import {
  EmailNotificationsUpdateRequestPayload,
  Technician,
  User,
  UsersQueryParams,
} from "../types/user";

import ApiService from "./ApiService";

type UsersResponse = {
  data: Technician[];
} & ResponseMeta &
  ResponseWarningQueries;

type CreateUserResponse = {
  data: {
    id: string;
  };
};

const UserService = {
  GetTechnicians: async (): Promise<UsersResponse> => {
    return ApiService.Get("employees", {
      sort: "firstName",
    });
  },

  GetCurrentUser: async (): Promise<{ data: Technician }> => {
    return ApiService.Get("users/me");
  },

  GetAdminsAndTechnicians: async (
    params: UsersQueryParams
  ): Promise<UsersResponse> => {
    return ApiService.Get(`users`, { ...params });
  },
  GetDeactivatedUsers: async (
    params: UsersQueryParams
  ): Promise<UsersResponse> => {
    return ApiService.Get(`users`, { ...params });
  },
  GetDeactivatedCustomerUsers: async (
    params: UsersQueryParams
  ): Promise<UsersResponse> => {
    return ApiService.Get(`customer-users`, { ...params });
  },
  CreateSBKUser: async (data: User): Promise<CreateUserResponse> => {
    return ApiService.Post("employees", data);
  },

  CreateCustomerUser: async (data: User): Promise<CreateUserResponse> => {
    return ApiService.Post("customer-users", data);
  },
  EditCustomerUser: async (
    id: string,
    data: User
  ): Promise<CreateUserResponse> => {
    return ApiService.Patch(`customer-users/${id}`, data);
  },
  EditSBKUser: async (id: string, data: User): Promise<CreateUserResponse> => {
    return ApiService.Patch(`employees/${id}`, data);
  },
  DeleteSBKUser: async (id: string, data: any): Promise<CreateUserResponse> => {
    return ApiService.Patch(`employees/${id}`, data);
  },
  DeleteCustomerUser: async (
    id: string,
    data: any
  ): Promise<CreateUserResponse> => {
    return ApiService.Patch(`customer-users/${id}`, data);
  },
  UpdateNotificationSettins: async (
    userId: string,
    data: EmailNotificationsUpdateRequestPayload
  ): Promise<any> => {
    return ApiService.Update("", `users/${userId}/notification-settings`, data);
  },
  ReactivateUser: async (
    route: string,
    id: string
  ): Promise<CreateUserResponse> => {
    return ApiService.Patch(`${route}/${id}`, {
      authSettings: {
        loginBlocked: false,
        loginBlockedReason: null,
      },
    });
  },
};

export default UserService;
